import React from 'react';
import PropTypes from 'prop-types';
import { TextArea, Typography } from '@telus-uds/components-web';

import { BoldFieldLabel, InputTitle, InputWrapper } from './css';
import Note from '../../note';
import formFieldOperationOptions from '../../utils/formFieldOperationOptions';
import FieldGuide from './common/fieldGuide';

const FieldMultiLineText = ({ data }) => {
  const {
    ref,
    name,
    label,
    value,
    title,
    required,
    onChange,
    placeholder,
    tooltip,
    note,
    disabled,
    noteAppearsBelowField,
    isShowNoteBackground,
    isColorRed
  } = data;
  // The UDS <TextArea> calls onChange with (newValue, event), unlike the native
  // <input> used by other fields which passes a DOM event. Adapt it to the
  // { target: { name, value } } shape the parent handler expects, otherwise
  // e.target is undefined and handleFormField throws (blocking typing).
  const handleChange = newValue => {
    onChange({ target: { name, value: newValue } }, ref);
  };
  const renderNotes = () => {
    return (
      note &&
      note.content && (
        <Note
          type="richText"
          options={formFieldOperationOptions(value)}
          data={note}
          isShowNoteBackground={isShowNoteBackground}
          isColorRed={isColorRed}
        />
      )
    );
  };

  return (
    <>
      {note && note.content && !noteAppearsBelowField && renderNotes()}
      {title && <InputTitle>{title}</InputTitle>}
      <InputWrapper>
        <BoldFieldLabel>
          <Typography block heading="h4" variant={{ size: 'h4', bold: true }}>
            {label}
            {required && `*`}
          {tooltip && (
            <span style={{ paddingLeft: '5px' }}>
              <FieldGuide tooltip={tooltip} />
            </span>
          )}
          </Typography>
        </BoldFieldLabel>
        {note && note.content && noteAppearsBelowField && renderNotes()}
        <TextArea
          ref={ref}
          id={name}
          name={name}
          value={value || ''}
          inactive={disabled}
          placeholder={placeholder}
          onChange={handleChange}
        />
      </InputWrapper>
    </>
  );
};

FieldMultiLineText.propTypes = {
  data: PropTypes.shape({
    ref: PropTypes.object,
    isColorRed: PropTypes.bool,
    placeholder: PropTypes.string,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    value: PropTypes.string,
    title: PropTypes.string,
    required: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    tooltip: PropTypes.string,
    note: PropTypes.shape({
      content: PropTypes.arrayOf(PropTypes.object)
    }),
    noteAppearsBelowField: PropTypes.bool.isRequired
  }).isRequired
};

export default FieldMultiLineText;
